import {
  CardContainer,
  PerformanceDashboardCard,
  useManageDashboardActions,
  IPerformanceReportCard,
  useEnvironment,
  IUser,
  DATA_EXPLORER,
  DEFAULT_ICON,
} from '@diana/core';
import { routeUrls } from '../../app/Routing/RouteUrls';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const PerformanceCard = (props: {
  id: string;
  iconData: IPerformanceReportCard['iconData'];
  key: string;
  displayName: IPerformanceReportCard['displayName'];
  setProcessing: (value: boolean) => void;
  acl: any;
  users: IUser[];
  permissionType: IPerformanceReportCard['permissionType'];
}) => {
  const { displayName, id, iconData, setProcessing, permissionType } = props;
  const environment = useEnvironment();
  const navigate = useNavigate();
  const { actions } = useManageDashboardActions({ id, setProcessing });

  const navigateToReport = useCallback(
    () => navigate(routeUrls.performanceReport.url({ environment, reportId: id }, null)),
    // eslint-disable-next-line
    [environment, id],
  );

  return (
    <CardContainer minHeight={'189px'}>
      <PerformanceDashboardCard
        actions={id !== DATA_EXPLORER ? actions : undefined}
        onClick={navigateToReport}
        title={displayName}
        icon={{
          imageUrl: iconData?.imageUrl ?? DEFAULT_ICON,
          color: iconData?.color ?? '',
          icon: iconData?.icon ?? '',
        }}
        dashboardType={id !== DATA_EXPLORER ? permissionType : undefined}
      />
    </CardContainer>
  );
};
